import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

import Vas from '../../Vas';

import '../../css/CreatePayment.css';

import { ExtendedButton,TextField,Icon,DateField,MessageBox,IbanField,Checkbox , AutocompleteField, SelectField} from 'component-lib';
import { DateTimeHelper,CheckValues, CheckFields } from 'utils-lib';
import { PaymentsModel, RequestAjaxClass,AdditionalAddressesModel,StreetsModel,CustomerModel, GenderModel} from 'models-lib';


var moment = require('moment');
        moment().format();

var changePaymentDate;

class CreatePayment extends Component
{
    constructor(props){
        super(props);
        this.state = {};
        this.CustomerId = props.match.params.CustomerId;
        this.NewContract = props.match.params.NewContract ? props.match.params.NewContract : false;
        this.PaymentId = props.match.params.PaymentId;
        
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);

        this.PaymentsModel = new PaymentsModel([this],null,this.Request);
        this.StreetsModel = new StreetsModel([this],null,this.Request2);
        this.CustomerModel = new CustomerModel([this],null,this.Request2);

        this.AdditionalAddressesModel = new AdditionalAddressesModel([this],null,this.Request2);
        this.GenderModel = new GenderModel([this], null, this.Request);

        this.state.CustomerEqualAccountOwner = true;
    }

    componentDidMount(){
      
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setAuth(true);

      this.Request2.setApiUrl(Vas.ApiUrl);
      this.Request2.setApiKey(Vas.ApiKey);
      this.Request2.setAuth(true);
      this.Request2.setErrorHandler((data)=>{
        this.refs.Create.setState({ usable:true });
        ReactDOM.render(<MessageBox 
          AppURL={Vas.ApplicationUrl} 
          Title={Vas.Resources.Labels["MethodOfPaymentCustomer"]} 
          Message={data.Description} /> 
                  , document.getElementById('messageContainer'));
          $("#LoadingIconPopUp").removeClass().addClass('hide');
      })

      this.CustomerModel.GetCustomerById(this.CustomerId);
      this.GenderModel.GetGender();
        this.setState({ requiredFields:[this.refs.accountOwnerName,this.refs.accountOwnerFirstName,this.refs.dateOfBirth,this.refs.iban2,this.refs.nameOfBank,this.refs.bic,this.refs.validFrom],
                  requiredCeckBox:[this.refs.AcceptPaymentTerms] },()=>{
            for (let i=0; i<this.state.requiredFields.length; i++){
                if (this.state.requiredFields[i].props.IsRequired){
                    this.state.requiredFields[i].setState({ Label:this.state.requiredFields[i].props.Label+"*" });
                }
            }
        });

        this.LogoClick();
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "CreatePaymentSetDateTo" || observer === "CreatePayment"){
          $("#LoadingIconPopUp").removeClass().addClass('hide');
          
          if(this.NewContract === "false"){
            Vas.GetView('CreatePaymentSuccess' , {CustomerId : me.CustomerId}, true);
          }else{
            Vas.GetView("Order", { CustomerId: me.CustomerId, ContractId : '00000' }, true);
          }
          
        }else if(observer === "ChangePayment"){
          Vas.GetView('ChangePaymentSuccess', {CustomerId : me.CustomerId}, true);
        }
        else if(observer === "Streets"){
          me.refs.streetAccountOwner.setState({ Data: me.StreetsModel.Streets, Icon :'' });
        } 
        else if( observer === "NewAdditionalAddress"){
          if(this.PaymentId === "000000"){
            this.PaymentsModel.CreatePaymentSetDateTo();
          }else{
            this.PaymentsModel.ChangePayment(this.PaymentId);
          }
        }
        else if(observer === "Gender"){
          let genderSelection = []
      
          if(this.GenderModel.Gender.length > 0){

            let genderArray = this.GenderModel.Gender;

            if(genderArray.length === 2) {
              genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] }];
            } else if(genderArray.length === 3){
              genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] },{ Key: genderArray[2], Display: 'divers' }];
            }
          }
          this.setState({GenderValues : genderSelection});
          
        }     
      })
    }

    createPayment(){

        let filled = this.checkFields();
        if ( filled === true){
            $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
            this.refs.Create.setState({ usable:false });
            
            $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
            this.PaymentsModel.PaymentOption.AccountOwner = this.AdditionalAddressesModel.Address.Name2 + " " + this.AdditionalAddressesModel.Address.Name1;
            this.PaymentsModel.PaymentOption.IsDefaultPaymentMethod = true;
            this.PaymentsModel.PaymentOption.PaymentMethodValue = 4;
                    
            this.PaymentsModel.CustomerId = this.CustomerId;
            this.Request.setErrorHandler((data)=>{
              this.refs.Create.setState({ usable:true });
              ReactDOM.render(<MessageBox 
                AppURL={Vas.ApplicationUrl} 
                Title={Vas.Resources.Labels["MethodOfPaymentCustomer"]} 
                Message={data.Description} /> 
                        , document.getElementById('messageContainer'));
                $("#LoadingIconPopUp").removeClass().addClass('hide');
            });

            if(this.state.CustomerEqualAccountOwner === false){
              this.AdditionalAddressesModel.Address.AddressType.Id = 52;
              this.AdditionalAddressesModel.Address.ValidFrom = this.PaymentsModel.PaymentOption.ValidFrom;
              this.AdditionalAddressesModel.SetNewAdditionalAddressByCustomerId(this.CustomerId);
            }else{
              if(this.PaymentId === "000000"){
                this.PaymentsModel.CreatePayment();
              }else{
                this.PaymentsModel.ChangePayment(this.PaymentId);
              }
            }

            

            
            
        }
    }

    checkIban()
    {
        let me = this;
      this.refs.nameOfBank.setState({ Icon:"Loop" });

      let valid = this.refs.iban2.getValid();
      if (valid[0] === true){
        if (valid[1]){
          me.refs.nameOfBank.setState({ Icon:'',Value:valid[1],editable:false });
          me.refs.bic.setState({ Value:valid[2],editable:false },()=>{
            this.checkBic();
          });
          
          this.PaymentsModel.PaymentOption.BankName = valid[1];
          this.PaymentsModel.PaymentOption.Iban = $('#iban2').val();
          
          me.setState({ PaymentDataValid:true });
          
        } else {
          $("#nameOfBank2").val('');
          $("#bic2").val('');
          me.refs.nameOfBank.setState({ Icon:'',Value:null,editable:true });
          me.refs.bic.setState({ Value:null,editable:true },()=>{
            this.checkBic();
          });
          
          this.PaymentsModel.PaymentOption.BankName = null;
          this.PaymentsModel.PaymentOption.Iban = $('#iban2').val();
          this.PaymentsModel.PaymentOption.Bic = null;
          
          me.setState({ PaymentDataValid:true });
        
        }
      } else {
        $("#iban2").val('');
        $("#nameOfBank2").val('');
        $("#bic2").val('');
        me.refs.nameOfBank.setState({ Icon:'',Value:null,editable:false });
        me.refs.bic.setState({ Value:null,editable:false },()=>{
          this.checkBic();
        });

        this.PaymentsModel.PaymentOption.BankName = null;
        this.PaymentsModel.PaymentOption.Iban = null;
        this.PaymentsModel.PaymentOption.Bic = null;

        me.setState({ PaymentDataValid:false });
      }
    }

    checkFields(){
        let count;

        if (this.state.requiredFields && this.state.requiredCeckBox){

            count=this.state.requiredFields.length + this.state.requiredCeckBox.length;
            let filled=0;

            for (let i=0;i<this.state.requiredFields.length;i++){
                if (this.state.requiredFields[i]){
                    if (document.getElementById(this.state.requiredFields[i].props.Id).value.length>0){
                            filled++;
                    }
                }
            }
              
            for (let j=0; j<this.state.requiredCeckBox.length;j++){
              if (this.state.requiredCeckBox[j]){
                  if (document.getElementById(this.state.requiredCeckBox[j].props.Id).checked === true){
                      filled++;
                  }
              }
            }

            if(this.state.CustomerEqualAccountOwner === false){
              count += this.state.requiredFieldsAccountOwner.length + this.state.requiredSelectFieldsAccountOwner.length ;
              
              filled+= CheckFields.CheckTextFields(this.state.requiredFieldsAccountOwner)[0];

              filled+=CheckFields.CheckSelectFields(this.state.requiredSelectFieldsAccountOwner)[0];
            }
            if (filled < count){
                let docs=document.querySelectorAll('select,input');
                let docRefs = this.refs;
                CheckValues.checkAllFields(docs,docRefs,"");
                ReactDOM.render(<MessageBox
                  Message={Vas.Resources.Labels["NotAllFields"]}
                  Title={Vas.Resources.Titles["Note"]} />,document.getElementById('messageContainer'));
                return false;
            } else {
                return true;
            }
        }
    }

    Close(){
      Vas.GetView("CustomerCard",{Id:this.CustomerId},true);
    }

    checkBic(){
        let bic = $("#bic2").val();
        if (bic.length === 11||bic.length === 8){
            this.refs.IconBic.setState({ Name:"Done",Color:"green" });
            
            this.PaymentsModel.PaymentOption.Bic = $("#bic2").val();
        } else {
            this.refs.IconBic.setState({ Name:"Warning",Color:"red" });
            $("#bic2").val('');
        }
    }

    checkAccountOwner(){
      if(this.AdditionalAddressesModel.Address.Name1.length > 0 && this.AdditionalAddressesModel.Address.Name2.length > 0 && this.AdditionalAddressesModel.Address.DateOfBirth.length > 0){
        if(this.AdditionalAddressesModel.Address.Name1 === this.CustomerModel.Customer.Name1 
          && this.AdditionalAddressesModel.Address.Name2 === this.CustomerModel.Customer.Name2 
          && DateTimeHelper.StringToDate(this.AdditionalAddressesModel.Address.DateOfBirth,true,localStorage.getItem('vas_language')).isSame(DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true,localStorage.getItem('vas_language')),'day') )
          {
            this.setState({CustomerEqualAccountOwner:true});
          }else {
            this.setState({CustomerEqualAccountOwner:false},()=>{
              this.setState({
                requiredFieldsAccountOwner:[this.refs.zipAccountOwner,
                  this.refs.cityAccountOwner,
                  this.refs.streetAccountOwner, 
                  this.refs.houseNumberAccountOwner
                ],
                requiredSelectFieldsAccountOwner:[this.refs.genderAccountOwner]
              });
              
              let genderSelection = [];
                    
              let genderArray = this.GenderModel.Gender;

              if(genderArray.length == 2) {
                genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] }];
              } else if(genderArray.length == 3){
                genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] },{ Key: genderArray[2], Display: 'divers' }];
              }
              
              this.refs.genderAccountOwner.setState({Data:genderSelection });
            });
          }
      }else{
        this.setState({CustomerEqualAccountOwner:true});
      }
    }

    getStreets(){
      if(this.AdditionalAddressesModel.Address.Zip.length > 0 && this.AdditionalAddressesModel.Address.City.length > 0){
        this.StreetsModel.GetStreets(this.AdditionalAddressesModel.Address.City,this.AdditionalAddressesModel.Address.Zip);
      }
    }

    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');
  
      if(kontrastNumber == "true"){

        $('.createPaymentForm').attr('style', 'border: 1px solid #1d5c87;');
        $('.createPaymentForm #PaymentTerms').attr('style', 'width: 170px; float: left; background-color: #1d5c87;');
        $('.createPaymentForm #CreatePayment').attr('style', 'width: 170px; float: left; background-color: #1d5c87;');
        $('.createPaymentForm #Cancel').attr('style', 'width: 180px; float: right; background-color: #1d5c87;');

        $('.createPaymentForm #iban2').attr('style', 'width: 315px; border-bottom: 1px dotted #1d5c87;');
        $('.createPaymentForm #bic2').attr('style', 'width: 320px; border-bottom: 1px dotted #1d5c87;');
        $('.createPaymentForm #nameOfBank2').attr('style', 'width: 350px; border-bottom: 1px dotted #1d5c87;');
        $('.createPaymentForm #ValidFrom').attr('style', 'width: 140px; float: left; border-bottom: 1px dotted #1d5c87;');
        $('.createPaymentForm #ValidTo').attr('style', 'width: 140px; float: left; border-bottom: 1px dotted #1d5c87;');

      }
    }

    render(){

      let address = <tr></tr>;
      if(this.state.CustomerEqualAccountOwner === false){
        address = <tr>
          <td>
            <table>
              <tbody>
                <tr>
                  <td>
                    <SelectField
                          Width={170}
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          ref={"genderAccountOwner"}
                          Data={this.state.GenderValues}
                          IsRequired={true}
                          Id={"GenderAccountOwner"}
                          //Float={'left'}
                          Label={Vas.Resources.Labels["Gender"]+ "*"}
                          OnChange={()=>{ this.AdditionalAddressesModel.Address.Gender = $("#GenderAccountOwner").val();}}
                          Tooltip={Vas.Resources.Tooltips["Gender"]} />
                  </td>
                </tr>
                <tr>
                  <td colSpan='2'>
                    <div className={"LeftContainer"}>
                      <TextField
                      Modus={"Number"}
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      ref={"zipAccountOwner"}
                      Id={"ZipAccountOwner"}
                      IsRequired={true}
                      Editable={true}
                      Label={Vas.Resources.Labels["Zip"]+ "*"}
                      Width={160}
                      OnBlur={()=>{ 

                        if ($("#ZipAccountOwner").val().length === 5){
                          this.AdditionalAddressesModel.Address.Zip = $("#ZipAccountOwner").val(); 
                        } else {
                          $("#ZipAccountOwner").val('');
                          ReactDOM.render(<MessageBox 
                            Message={Vas.Resources.Labels["PLZNote"]} 
                            Title={Vas.Resources.Titles["Note"]} />
                              ,document.getElementById('messageContainer'));
                        }
                      }} />
                    </div>
                    <div className={"RightContainerAccountOwner"} >
                        <TextField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        ref={"cityAccountOwner"}
                        Id={"CityAccountOwner"}
                        IsRequired={true}
                        Editable={true}
                        Width={160}
                        Label={Vas.Resources.Labels["Place"]+ "*"}
                        OnChange={()=>{ this.AdditionalAddressesModel.Address.City = $("#CityAccountOwner").val() ; }}
                        OnBlur={()=>{this.getStreets("AccountOwner");}} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}><AutocompleteField
                    AppURL={Vas.ApplicationUrl}
                    TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
                    MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]}
                    me={this}
                    Width={346}
                    Modus={"Street"}
                    IsRequired={true}
                    ref={"streetAccountOwner"}
                    Id={"StreetAccountOwner"}
                    Float={'left'}
                    editable={true}
                    Label={Vas.Resources.Labels["Street"]+ "*"}
                    Data={this.state.streets}
                    OnBlur={()=>{ this.AdditionalAddressesModel.Address.Street = $("#StreetAccountOwner").val();}}
                    Tooltip={Vas.Resources.Tooltips["Street"]}
                    TimeOutTime={Vas.TimeOutTime} /></td>
                </tr>
                <tr>
                  <td colSpan='2'>
                    <div className={"LeftContainer"}>
                      <TextField
                      Modus={"Number"}
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      Editable={true}
                      Width={160}
                      ref={"houseNumberAccountOwner"}
                      IsRequired={true}
                      Id={"HouseNumberAccountOwner"}
                      Label={Vas.Resources.Labels["HouseNumber"]+ "*"}
                      OnChange={()=>{
                        this.AdditionalAddressesModel.Address.HouseNumber = $("#HouseNumberAccountOwner").val(); 
                      }} /></div>
                    <div className={"RightContainerAccountOwner"} >
                      <TextField
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      Editable={true}
                      Width={160}
                      ref={"houseNumberAdditionAccountOwner"}
                      Id={"HouseNumberAdditionAccountOwner"}
                      Label={Vas.Resources.Labels["HouseNumberAddition"]}
                      OnChange={()=>{ this.AdditionalAddressesModel.Address.HouseNumberAddition = $("#HouseNumberAdditionAccountOwner").val(); }} /></div>
                    </td>
                </tr>
                <tr>
            <td colSpan={2}><TextField
              AppURL={Vas.ApplicationUrl}
              me={this}
              Editable={true}
              Width={346}
              ref={"adressAdditionAccountOwner"}
              Id={"AddressAdditionAccountOwner"}
              Label={Vas.Resources.Labels["AdditionAdress"]}
              OnChange={()=>{ this.AdditionalAddressesModel.Address.Name3 = $("#AddressAdditionAccountOwner").val() ; }} /></td>
          </tr>
              </tbody>
            </table>
          </td>
        </tr>
      }

      let headerText = Vas.Resources.Titles["CreatePayment"];
      let hint = "";
      let buttonText = Vas.Resources.Labels["CreateMethodOfPayment"];

      if(this.PaymentId !== "000000"){

        headerText = Vas.Resources.Labels["ChangePaymentData"];
        hint = Vas.Resources.Labels["ChangePaymentHint"];
        buttonText = headerText;

        var paymentUpdateDateString = localStorage.getItem("PaymentUpdateDate");

        if(paymentUpdateDateString !== null && paymentUpdateDateString !== undefined && paymentUpdateDateString !== ""){

          var paymentUpdateDateArray = paymentUpdateDateString.split('-');

          changePaymentDate = moment([paymentUpdateDateArray[0], paymentUpdateDateArray[1] - 1, paymentUpdateDateArray[2]]);
        } else{

          changePaymentDate = moment();
        }

      } else{

        changePaymentDate = moment();
      }

    return (
      <div className={"form createPaymentForm"}>
        <table>
          <thead>
            <tr>
              <th>
                <h2>{headerText}</h2>
              </th>
            </tr>
            <tr>
              <th colSpan={2}>
                <div id={"createPaymentHint"}>
                  {hint}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <table style={{textAlign:'justify'}}>
                  <tbody>
                    <tr>
                      <td>
                      <br/>
                        <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
                      </td>
                      
                    </tr>
                    <tr>
                        <td>
                          <div className={"LeftContainer"}><TextField
                            AppURL={Vas.ApplicationUrl}
                            me={this}
                            ref={"accountOwnerName"}
                            Id="accountOwnerName"
                            Editable={true}
                            IsRequired={true}
                            Label={Vas.Resources.Labels["DepositorName"]}
                            OnChange={()=>{ this.AdditionalAddressesModel.Address.Name1 = $("#accountOwnerName").val() ; this.checkAccountOwner();}}
                            Width={160}
                            /></div>
                          <div className={"RightContainer"}><TextField
                            AppURL={Vas.ApplicationUrl}
                            me={this}
                            ref={"accountOwnerFirstName"}
                            Id="accountOwnerFirstName"
                            Editable={true}
                            IsRequired={true}
                            Label={Vas.Resources.Labels["DepositorFirstname"]}
                            OnChange={()=>{ this.AdditionalAddressesModel.Address.Name2 = $("#accountOwnerFirstName").val() ;this.checkAccountOwner(); }}
                            Width={160}
                             /></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                        <div className={"LeftContainer"}>
                          <DateField
                            AppURL={Vas.ApplicationUrl}
                            Language={localStorage.getItem("vas_language")}
                            me={this}
                            Width={170}
                            Float={'left'}
                            Editable={true}
                            ref={"dateOfBirth"}
                            IsRequired={true}
                            MaxValue={moment([moment().year() - 18, moment().month(), moment().date() + 1])}
                            Id={"DateOfBirth"}
                            Label={Vas.Resources.Labels["DateOfBirth"]}
                            OnBlur={()=>{ 
                              let cur = DateTimeHelper.StringToDate($("#DateOfBirth").val(),false,localStorage.getItem('vas_language'));
                              this.AdditionalAddressesModel.Address.DateOfBirth = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DDT00:00:00");
                              this.checkAccountOwner(); }} />
                          </div>
                        </td>
                      </tr>
                      {address}
                    <tr>
                      <td colSpan={2}><IbanField
                        AppURL={Vas.ApplicationUrl}
                        ApiUrl={Vas.ApiUrl}
                        ApiKey={Vas.ApiKey}
                        Token={localStorage.getItem["vas_token"]}
                        AnonymousToken={localStorage.getItem["anonymous_token"]}
                        me={this}
                        ref={"iban2"}
                        Width={315}
                        Id="iban2"
                        Editable={true}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["Iban"]}
                        OnBlur={()=>{this.checkIban();}} /> </td><td></td>
                    </tr>
                    <tr>
                      <td colSpan={2}><TextField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        ref={"bic"}
                        Width={320}
                        Id="bic2"
                        Editable={false}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["Bic"]}
                        OnBlur={()=>{this.checkBic();}}
                        Tooltip={Vas.Resources.Tooltips["BicLength"]} /><Icon
                          ref={"IconBic"}
                          Name={"Warning"}
                          Size={24}
                          Color={"red"}
                          Align={"left"} /></td>
                    </tr>
                    <tr>
                      <td colSpan={2}><TextField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        ref={"nameOfBank"}
                        Width={350}
                        Id="nameOfBank2"
                        Editable={false}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["NameOfBank"]}
                        OnBlur={()=>{ this.PaymentsModel.PaymentOption.BankName = $("#nameOfBank2").val() ;}} /></td>
                    </tr>
                    <tr>
                      <td>

                        <div className="LeftContainer" ><DateField
                          MinValue={ changePaymentDate }
                          AppURL={Vas.ApplicationUrl}
                          Language={localStorage.getItem("vas_language")}
                          me={this}
                          Width={170}
                          Float={'left'}
                          Editable={true}
                          ref={"validFrom"}
                          IsRequired={true}
                          Id={"ValidFrom"}
                          Tooltip={Vas.Resources.Tooltips["PaymentValidFrom"]}
                          Label={Vas.Resources.Labels["ValidFrom"]}
                          OnBlur={()=>{ 
                            let cur = DateTimeHelper.StringToDate($("#ValidFrom").val(),false,localStorage.getItem('vas_language'));
                            this.PaymentsModel.PaymentOption.ValidFrom = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DD T 00:00:00");
                            
                          }}
                        /></div>
                        <div className="RightContainer"><DateField
                          MinValue={ changePaymentDate }
                          AppURL={Vas.ApplicationUrl}
                          Language={localStorage.getItem("vas_language")}
                          me={this}
                          Width={170}
                          Float={'left'}
                          Editable={true}
                          ref={"validTo"}
                          IsRequired={false}
                          Id={"ValidTo"}
                          Tooltip={Vas.Resources.Tooltips["PaymentValidTo"]}
                          Label={Vas.Resources.Labels["ValidTo"]}
                          OnBlur={()=>{
                            let cur = DateTimeHelper.StringToDate($("#ValidTo").val(),false,localStorage.getItem('vas_language'));
                            this.PaymentsModel.PaymentOption.ValidTo = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DD T 00:00:00");
                             
                          }}
                        /></div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <Checkbox
                                  ref={"AcceptPaymentTerms"}
                                  Id={"checkboxAcceptPaymentTerms"}
                                  onClick={()=>{this.setState({ AcceptPaymentTerms:$("#checkboxAcceptPaymentTerms").val() });}} />
                              </td>
                              <td>
                                {/*<div className={"ConfirmationLabel"}><label htmlFor="cbox" ><a
                                  href={Vas.ApplicationUrl+"/ErteilungSEPA.pdf"}
                                  target="_blank"
                        rel="noopener noreferrer" >{Vas.Resources.Labels["SEPA"]}*</a> </label></div>*/}
                                <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["SEPA"]}*</div>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={2}>
                                <ExtendedButton
                                  Id={"PaymentTerms"}
                                  Usable={true}
                                  Text={ Vas.Resources.Labels["ViewHere"] }
                                  Width={170}
                                  Float={"left"}
                                  OnClick={() => { window.open(Vas.ApplicationUrl+"/ErteilungSEPA.pdf") }} />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                  </tr>
                    <tr>
                      <td ><br /><br />
                        <div id={"buttonsContainerCreatePayment"} style={{ width: '365px'}}>
                            <ExtendedButton
                              ref={"Create"}
                              Usable={true}
                              Text={buttonText}
                              Float={'left'}
                              OnClick={()=>{this.createPayment();}}
                              Id={"CreatePayment"}
                              Width={170}/>

                            <ExtendedButton
                              ref={"Cancel"}
                              Usable={true}
                              Text={Vas.Resources.Labels["Cancel"]}
                              Float={'right'}
                              OnClick={()=>{this.Close();}}
                              Id={"Cancel"}
                              Width={170}/>
                        </div>
                        </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      );
    }
}
export default CreatePayment;
